import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74d6b60b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "main_title" };
const _hoisted_3 = { class: "main_box" };
const _hoisted_4 = { class: "flex contents" };
const _hoisted_5 = { class: "flex buttons" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    emits: ["close"],
    setup(__props, { emit }) {
        const { format, STAKING_LIST_TITLES } = useMessage();
        const onClose = () => {
            emit('close');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "overlay overlay_z",
                    onClick: onClose
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).CANCEL_SUCCESS)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(MaterialIcon, {
                                class: "icon check-icon",
                                name: "done"
                            })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            onClick: onClose,
                            class: "close"
                        }, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).RETURN)), 1)
                    ])
                ])
            ], 64));
        };
    }
});
